import { fromJS, isMap } from "immutable"
import { call, select, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { updateEventsDataEventCall } from "../../apis/wpApi/apiCalls"
import authUser from "../../apis/wpApi/authUser"
import { checkResponse, putError, putSuccess } from "../helpers"
import { EVENT_DATA } from "../../constants/state"
import moment from "moment"
import { overlaySetRequestType } from "../programSaga/helpers/request"


const selectItem = (state, id) => state.getIn([EVENT_DATA, 'events', 'data', 'items', String(id)])

function* getProvider(provider, p) {
    if(false === provider || ('form_data' === provider && 'edited_data' === p)) {
        provider = yield p
    }

    return provider
}

function* getProviderFromData(formData, newData, provider = false)  {
    if(isMap(newData)) {
        const objKeys = yield newData.keySeq().toArray()

        for(let i = yield 0; yield i < objKeys.length; yield i++) {
            const key = yield objKeys[i]
            const p = yield call(getProviderFromData, formData.get(key), newData.get(key), provider)

            provider = yield call(getProvider, provider, p)
        }
    } else {
        const p = yield formData === newData ? 'form_data' : 'edited_data'

        provider = yield call(getProvider, provider, p)
    }

    return yield provider
}

function* getUpdateData(updates, item) {
    const updateKeys = yield Object.keys(updates)

    for(let i = yield 0; yield i < updateKeys.length; yield i++) {
        const key = yield updateKeys[i]
        const update = yield fromJS(updates[key])
        const oldProvider = yield item.getIn(['meta_data', key, 'provider'])
        const oldData = yield item.getIn([oldProvider, key])
        const formData = yield 'form_data' === oldProvider ? oldData : item.getIn(['form_data', key])
        const newData = yield isMap(update) ? oldData.mergeDeep(update) : update
        const newProvider = yield call(getProviderFromData, formData, newData)

        if('form_data' === newProvider) {
            item = yield item.setIn(['edited_data', key], false)
        } else {
            item = yield item.setIn(['edited_data', key], fromJS(newData))
        }

        item = yield item.setIn(['meta_data', key, 'provider'], newProvider)
    }

    item = yield item.set('updated_at', moment().format("YYYY-MM-DDTHH:mm:ssZ"))

    return yield item.toJS()
}

function* updateEvent(payload) {
    try {
        yield overlaySetRequestType(actionTypes.EVENTS_EVENTS_UPDATE_REQUEST)

        const { id , data } = yield payload.payload

        if(!id) {
            throw new Error('No id')
        }

        if(!data)  {
            throw new Error('No data')
        }

        if(!Object.keys(data).length) {
            throw new Error('No updates')
        }
       
        const apiKey = yield call(authUser.getToken)
        const item =   yield select(selectItem, id)

        if(!item) { //ToDo: testen
            throw new Error('No event to update found')
        }

        const updatedEventData = yield call(getUpdateData, data, item)
        const response = yield call(updateEventsDataEventCall, apiKey, updatedEventData)
        
        yield call(checkResponse, response)
        yield call(putSuccess, actionTypes.EVENTS_EVENTS_UPDATE_SUCCESS, { data: response.data})
    } catch(e) {
        yield call(putError, actionTypes.EVENTS_EVENTS_UPDATE_ERROR, e.message)
    }
}


function* watchEventUpdateRequest() {
    try {
        yield takeLatest(actionTypes.EVENTS_EVENTS_UPDATE_REQUEST, updateEvent)
    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchEventUpdateRequest;